// src/app/app.routes.ts

import { Routes } from '@angular/router';

export const routes: Routes = [
  // Default redirect
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // Auth routes
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component')
      .then(m => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./features/auth/register/register.component')
      .then(m => m.RegisterComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/auth/forget-password/forget-password.component')
      .then(m => m.ForgetPasswordComponent)
  },

  // Main routes
  { path: 'dashboard', redirectTo: 'dashboard/app', pathMatch: 'full' },
  {
    path: 'dashboard/:section',
    loadComponent: () => import('./features/dashboard/dashboard.component')
      .then(m => m.DashboardComponent)
  },
  // {
  //   path: 'connect',
  //   loadComponent: () => import('./features/connect/connect.component')
  //     .then(m => m.ConnectComponent)
  // },
  {
  path: 'connect',
  redirectTo: 'dashboard/connect',
  pathMatch: 'full'
},
  {
    path: 'affiliate',
    loadComponent: () => import('./features/affiliate/affiliate.component')
      .then(m => m.AffiliateComponent)
  },
  {
    path: 'payment',
    loadComponent: () => import('./features/payment/payment.component')
      .then(m => m.PaymentComponent)
  },
  {
    path: 'suggestion',
    loadComponent: () => import('./features/suggestions/suggestions.component')
      .then(m => m.SuggestionsComponent)
  },
  {
    path: 'support',
    loadComponent: () => import('./features/support/support.component')
      .then(m => m.SupportComponent)
  },

  // Old redirects
  { path: 'auth/login', redirectTo: 'login', pathMatch: 'full' },
  { path: 'auth/register', redirectTo: 'register', pathMatch: 'full' },

  // Wildcard
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];